/**
 * Season summary screen tonnes (modal + scorecards). PDF keeps full tonnes.
 * Always en-US; K/M use one decimal including trailing zero. No unit suffix.
 */
export function formatCompactTonnes(value) {
  const n = Number(value);
  if (!Number.isFinite(n) || n <= 0) return '—';
  if (n < 1) return '<1';
  if (n >= 1e6) return `${(n / 1e6).toFixed(1)}M`;
  if (n >= 1000) return `${(n / 1000).toFixed(1)}K`;
  return String(Math.round(n));
}
